import Button from '@orn/shared-web/components/Button/Button';
import { InfoCircleIcon } from '@orn/shared-web/icons';

import { useEmptyStateDateLabel, usePresetDateRange, type CalendarDateRange } from '../../../DateRangePicker';

import type { HasTransactionsForUserQuery } from '../../hooks/__generated__/useHasTransactionsForEmptyState.gql';

type HasTransactionsResult = Pick<
  NonNullable<HasTransactionsForUserQuery['hasTransactionsForUser']>,
  'exists' | 'count' | 'startDate' | 'endDate'
>;

export interface IEmptyTableStateProps {
  hasTransactionsResult?: HasTransactionsResult | null;
  currentDateRange?: CalendarDateRange;
  onViewTransactions: (range: CalendarDateRange) => void;
}

const EmptyTableState = ({ hasTransactionsResult, currentDateRange, onViewTransactions }: IEmptyTableStateProps) => {
  const emptyStateDateLabel = useEmptyStateDateLabel(currentDateRange);
  const allTimeDateRange = usePresetDateRange('allTime');
  const hasMoreTransactions =
    hasTransactionsResult?.exists &&
    (hasTransactionsResult.count ?? 0) > 0 &&
    hasTransactionsResult.startDate != null &&
    hasTransactionsResult.endDate != null &&
    currentDateRange != null;

  const content = hasMoreTransactions ? (
    <>
      <div className="text-primary text-center text-lg font-medium">No matching transactions {emptyStateDateLabel}</div>
      <div className="text-tertiary flex items-center gap-1 text-center text-sm">
        <InfoCircleIcon className="size-3.5 shrink-0" />
        <span>
          We found <span className="font-semibold">{hasTransactionsResult.count}</span>{' '}
          {hasTransactionsResult.count === 1 ? 'transaction' : 'transactions'} outside of the period
        </span>
      </div>
      <Button
        className="min-w-49 mt-5"
        size="md"
        color="primary"
        onClick={() => {
          onViewTransactions(allTimeDateRange);
        }}
      >
        View {hasTransactionsResult.count} {hasTransactionsResult.count === 1 ? 'transaction' : 'transactions'}
      </Button>
    </>
  ) : (
    <div className="text-primary text-center text-lg font-medium">No matching transactions {emptyStateDateLabel}</div>
  );

  return <div className="flex h-56 flex-col items-center justify-center px-6 pb-4 pt-3">{content}</div>;
};

export default EmptyTableState;
